$(document).on('ready', function () {

    "use strict";

    if ($('.featuredVehicles ul').length) {

        $('.featuredVehicles ul').slick({
            dots: false,
            infinite: false,
            arrows: true,
            autoplay: false,
            waitForAnimate: false,
            autoplaySpeed: 4000,
            draggable: true,
            speed: 600,
            slidesToShow: 2,
            slidesToScroll: 2,
            swipeToSlide: false,
            variableWidth: true,
            prevArrow: '<button type="button" data-role="none" class="slick-prev postsArrow" aria-label="Previous" tabindex="0" role="button"><i class="fa fa-angle-left"></i></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next postsArrow" aria-label="Next" tabindex="0" role="button"><i class="fa fa-angle-right"></i></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: window.breakpoints.mobile,
                    settings: {
                        dots: true,
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                        //infinite: true,
                        //variableWidth: false
                    }
                }
            ]
        });
    }
});